
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["formatCode","convertTSCodeToJSCode"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "047d1b8975eb259e153c.worker.js", { name: "[fullhash].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "047d1b8975eb259e153c.worker.js");
					addMethods(w, methods)
					
					return w
				}
			